/**
 * Regulars a destination Events strip showed, and the ones opened: report-only
 * counts for a later "shown often, never opened" demotion for locals
 * (server/services/regularStripViewsService.js; docs/PLACE_ACTIVITIES.md).
 * Fire and forget: a failure loses a count, never anything the person sees.
 */

import { API_BASE } from '../config/api';
import AuthService from './authService';

const ENDPOINT = `${API_BASE}/api/destinations/regular-views`;

// A strip counts once per city and set of regulars per half hour: re-renders,
// StrictMode's double effects and a quick back-and-forth are one view.
const STRIP_WINDOW_MS = 30 * 60 * 1000;
const lastStrip = new Map();

function send(body, { keepalive = false } = {}) {
  fetch(ENDPOINT, { method: 'POST', headers: AuthService.getJsonHeaders(), body: JSON.stringify(body), keepalive })
    .catch(() => {});
}

/** The regulars one strip placed (their ids), on the page for `scopeKey`. */
export function recordRegularStripView(ids, scopeKey) {
  if (!ids || ids.length === 0) return;
  const key = `${scopeKey}|${ids.join(',')}`;
  const now = Date.now();
  if (now - (lastStrip.get(key) || 0) < STRIP_WINDOW_MS) return;
  lastStrip.set(key, now);
  send({ shown: ids });
}

/** A regular's card was opened. keepalive: the tap navigates away. */
export function recordRegularOpened(id) {
  if (!id) return;
  send({ opened: id }, { keepalive: true });
}

/** For tests. */
export function _resetRegularStripViews() {
  lastStrip.clear();
}
